import React, { useEffect, useState } from "react";
import { Button, Skeleton } from "antd";
import useQuery from "../../../../hooks/useQuery";
import { viewIpBedApi } from "../../../../services/receptionist.services";
import { CalendarOutlined } from "@ant-design/icons";
import { formatToINR } from "../../../../helpers/utility";
import dayjs from "dayjs";
import styles from "./ViewBeds.module.css";

const ViewBeds = ({ setEditBed, setSwitchBed, bedId, patientData }) => {
  const params = useQuery();
  const [bedsData, setBedsData] = useState([]);
  const admission = patientData?.admission?.is_active;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    viewIpBedApi(params?.patient)
      .then((res) => {
        setBedsData(res?.data?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [params?.patient]);

  const renderCardAction = (record) => {
    const startDate = dayjs(record?.start_date || record?.created_at);
    const timeDiff = dayjs().diff(startDate, "minute");

    if (record?.bed?.id === bedId && !record?.end_date) {
      if (timeDiff > 1) {
        return (
          <Button
            onClick={() => setSwitchBed(true)}
            className={styles.actionBtn}
          >
            Switch Bed
          </Button>
        );
      }

      return (
        <Button onClick={() => setEditBed(true)} className={styles.actionBtn}>
          Edit Bed
        </Button>
      );
    }

    return null;
  };

  const formatDateTime = (value) =>
    value ? dayjs(value).format("DD MMM, YYYY hh:mm A") : null;

  return (
    <div>
      {loading ? (
        <Skeleton active />
      ) : (
        bedsData?.map((record) => (
          <div key={record?.bed?.id ?? record?.id} className={styles.card}>
            <div className={styles.topRow}>
              <div className={styles.topField}>
                <div className={styles.fieldLabel}>Bed No</div>
                <div className={`${styles.valueChip} ${styles.bedNoChip}`}>
                  {record?.bed?.bed_no || "—"}
                </div>
              </div>
              <div className={styles.topField}>
                <div className={styles.fieldLabel}>Room No</div>
                <div className={`${styles.valueChip} ${styles.roomNoChip}`}>
                  {record?.bed?.room_no || "—"}
                </div>
              </div>
              <div className={styles.topField}>
                <div className={styles.fieldLabel}>Room Type</div>
                <div className={`${styles.valueChip} ${styles.roomTypeChip}`}>
                  {record?.bed?.room_type || "—"}
                </div>
              </div>
              <div className={styles.topField}>
                <div className={styles.fieldLabel}>Cash Price</div>
                <div className={styles.priceBox}>
                  {formatToINR(record?.bed?.cash_price)}
                </div>
              </div>
              <div className={styles.topField}>
                <div className={styles.fieldLabel}>Insurance Price</div>
                <div className={styles.priceBox}>
                  {formatToINR(record?.bed?.insurance_price)}
                </div>
              </div>
            </div>

            <div className={styles.divider} />

            <div className={styles.bottomRow}>
              <div className={styles.dateFieldsGroup}>
                <div className={styles.bottomField}>
                  <div className={styles.fieldLabel}>Start Date</div>
                  <div className={styles.dateBox}>
                    <span>
                      {formatDateTime(
                        record?.start_date || record?.created_at
                      ) || "—"}
                    </span>
                    <CalendarOutlined className={styles.dateIcon} />
                  </div>
                </div>
                <div className={styles.bottomField}>
                  <div className={styles.fieldLabel}>End Date</div>
                  <div className={styles.dateBox}>
                    <span
                      className={
                        !record?.end_date ? styles.datePlaceholder : undefined
                      }
                    >
                      {formatDateTime(record?.end_date) || "------"}
                    </span>
                    <CalendarOutlined className={styles.dateIcon} />
                  </div>
                </div>
              </div>
              <div className={styles.actions}>
                {admission && renderCardAction(record)}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ViewBeds;
